import { Component, Input, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { getTenantStorage } from '../../../_shared/utils/tenant-context';

import { AlertService, FileStoreService, IAlertType } from "../../../_shared/services";
import { Files } from "../../../_shared/interfaces";
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule, ClrModalModule } from "@clr/angular";
import { NgIf } from "@angular/common";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { UploadComponent } from "../../../core/upload/upload.component";
import { ClarityIcons, timesCircleIcon } from "@cds/core/icon";

import { environment as env } from "../../../../environments/environment";
import { filesBaseUrl } from "../../../_shared/utils/rest-url";

@Component({
  selector: 'app-contact-files-card',
  standalone: true,
  imports: [
    ClrDatagridModule,
    NgIf,
    ClrIconModule,
    ClrModalModule,
    NgxExtendedPdfViewerModule,
    UploadComponent
  ],
  templateUrl: './contact-files-card.component.html',
  styleUrl: './contact-files-card.component.sass'
})

export class ContactFilesCardComponent implements OnInit {
  files: Files[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  showFileUpload: boolean = false;
  showPDF: boolean = false;
  modalUrl: string = '';
  modalContent: string = '';

  private filesDirectory = filesBaseUrl();

  @Input() companyId: number = 0;

  constructor(
    private filess: FileStoreService,
    public alertDispatcher: AlertService
  ) {
    ClarityIcons.addIcons(timesCircleIcon)
  }

  ngOnInit(): void {
    this.loading = true;
    this.showFileUpload = false;
    this.showPDF = false;
    this.loadList(this.companyId);
  }

  loadList(companyID: number) {
    this.filess.getCompanyFiles(companyID).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.files = [];
          this.alertDispatcher.alertConfig.message = 'Keine Dateien gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.files = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return}
    })
  }


  showModal(fileid: string) {
    const phmToken = getTenantStorage('access_token');
    this.modalUrl = `${this.filesDirectory}/download_file?file_id=${fileid}&token=${phmToken}`;
    this.showPDF = true;
  }

  closeModal(state: boolean) {
    this.loading = true;
    this.loadList(this.companyId);
    this.showFileUpload = state;
  }

  showFileUploader() {
    this.showFileUpload = true;
  }

  deleteFile(fileID: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.filess.deleteFile(fileID)
        .subscribe({
          next: () => {
            this.files = this.files.filter(file => file.id !== fileID);
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde gelöscht. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
          },
          complete: () => {
            this.loadList(this.companyId)
          },
          error: () => {
            return
          }
        })
    }
  }

  loadFile(fileID: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' herunterladen?')) {
      this.filess.downloadFile(fileID)
        .subscribe({
          next: data => {
            if (!data) {
              this.alertDispatcher.alertConfig.message = 'Keine Datei gefunden!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              return;
            }
            saveAs(data, fileName);
          },
          complete: () => {
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde heruntergeladen. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
          },
          error: () => {
            return
          }
        })
    }
  }
}
